module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/menu_gift-e022f87bd79ff4cec5c705a1a6404cad.png";